module.exports = __webpack_public_path__ + "static/media/memories.dab25ad8.png";